import React, { Component } from 'react';

class Header extends Component {
  render() {
    if(!this.props.data || !this.props.data.address || !this.props.data.social){
      return <header id="home"></header>;
    }

    var name = this.props.data.name;
    var occupation= this.props.data.occupation;
    var description= this.props.data.description;
    var profilepic = "images/" + this.props.data.image;
    var hasTestimonials = this.props.data.hasTestimonials;
    var highlights = this.props.data.highlights || [];
    var networks= this.props.data.social.map(function(network){
      return <li key={network.name}><a href={network.url}><i className={network.className}></i></a></li>
    });
    var highlightItems = highlights.map(function(item){
      return <li key={item}>{item}</li>;
    });

    return (
      <header id="home">

      <nav id="nav-wrap">

         <a className="mobile-btn" href="#nav-wrap" title="Show navigation">Show navigation</a>
	      <a className="mobile-btn" href="#home" title="Hide navigation">Hide navigation</a>

         <ul id="nav" className="nav">
            <li className="current"><a className="smoothscroll" href="#home">Home</a></li>
	         <li><a className="smoothscroll" href="#about">Resume</a></li>
            <li><a className="smoothscroll" href="#skills">Skills</a></li>
            <li><a className="smoothscroll" href="#certifications">Certifications</a></li>
            <li><a className="smoothscroll" href="#portfolio">Projects</a></li>
            {hasTestimonials ? <li><a className="smoothscroll" href="#testimonials">Testimonials</a></li> : null}
            <li><a className="smoothscroll" href="#contact">Contact</a></li>
         </ul>

      </nav>

      <div className="row banner">
         <div className="hero-profile">
            <img src={profilepic} alt={name + " profile"} className="hero-profile-image" />
         </div>
         <div className="banner-text">
            <div className="hero-ribbon">
              <p>SOLUTIONS ARCHITECT | DISTRIBUTED SYSTEMS | SCALABLE PLATFORMS | GOVTECH</p>
            </div>
            <h1 className="responsive-headline">{name}</h1>
            <h3><span>{occupation}</span><br/> {description}.</h3>
            <ul className="banner-highlights">
               {highlightItems}
            </ul>
            <hr />
            <ul className="social">
               {networks}
            </ul>
         </div>
      </div>

      <p className="scrolldown">
         <a className="smoothscroll" href="#about"><i className="icon-down-circle"></i></a>
      </p>

   </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Header.js